<script>
    import { onMount } from "svelte";
    import { API_URL } from "./Var.svelte"


    const api_host = API_URL;

    let who = [];
    $: who
	const url = `${api_host}/who`;

    async function fetchData() {
        const response = await fetch(url);
        who = await response.json();
    }

    onMount(() => {
    
    const interval = setInterval(fetchData, 5000);
    fetchData();

    return () => clearInterval(interval);
  });
</script>

<header>
    <div>
    {#if who.error}
    <h1>Offline :(</h1>
    {:else if who.display_name}
    <!-- <img class="juke-box" src="favicon.png" alt="loading"> -->
    <h1>JukEbox</h1>
    <img class="juke-box" src="favicon.png" alt="loading">
    {:else}
    <img src="Ellipsis-1.5s-200px.svg" alt="loading">
    {/if}
    </div>
</header>

<style>
    div {
        display: flex;
        background-color: #191414;
        color: aliceblue;
        justify-content: center;
        align-items: center;
        height: 100px;
    }

    div img {
        background-color: none;
        /* width: 100%; */
        height: 6em;
    }

    .juke-box {
        height: 3em;
        margin-left: 1em;
        margin-right: 1em;
    }
</style>